import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTE_PATH } from '@/constants/routes';
import { useLanguageMenu } from '@/hooks/useLanguageMenu';

interface ShareDeviceHeaderProps {
  showBackToTop?: boolean;
  onBackToTop?: () => void;
  showLanguageMenu?: boolean;
}

export const ShareDeviceHeader = ({
  showBackToTop = false,
  onBackToTop,
  showLanguageMenu = true,
}: ShareDeviceHeaderProps) => {
  const { t } = useTranslation();
  const {
    i18n,
    isLanguageMenuOpen,
    languageRef,
    toggleLanguageMenu,
    changeLanguage,
  } = useLanguageMenu();

  return (
    <header className="header">
      <div className="header__line">
        <div className="header__inner">
          <div className="header__logo">
            <Link className="header__logo-link" to={ROUTE_PATH.SHARE_DEVICE}>
              <img
                className="header__logo-img"
                src="/Common_ANA_Logo.svg"
                alt={t('common.altText.anaLogo')}
              />
            </Link>
          </div>
          <div className="header__menu">
            {showBackToTop && (
              <div className="header__back">
                <a className="header__back-link" onClick={onBackToTop}>
                  {t('common.backToTop')}
                </a>
              </div>
            )}
            {showLanguageMenu && (
              <div
                className={`header__language ${isLanguageMenuOpen ? 'header__language--open' : ''}`}
                ref={languageRef}
              >
                <button
                  className="header__language-toggle"
                  type="button"
                  onClick={toggleLanguageMenu}
                >
                  <img
                    className="header__language-icon"
                    src="/Common_Icon_Language.png"
                    alt={t('common.altText.languageIcon')}
                  />
                </button>
                <div className="header__language-list">
                  <div
                    className={`header__language-item ${i18n.language === 'ja' ? 'is-selected' : ''}`}
                    data-lang="ja"
                    onClick={() => changeLanguage('ja')}
                  >
                    <span className="header__language-label header__language-label--ja">
                      {t('shareDevice.languageButtons.japanese')}
                    </span>
                  </div>
                  <div
                    className={`header__language-item ${i18n.language === 'en' ? 'is-selected' : ''}`}
                    data-lang="en"
                    onClick={() => changeLanguage('en')}
                  >
                    <span className="header__language-label header__language-label--en">
                      {t('shareDevice.languageButtons.english')}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
